<template>
  <div class="loginMain">
    <div class="loginBanner">
      <swiper :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide class="head">
          <div class="first">
            <div class="swiperCon"></div>
          </div>
        </swiper-slide>
        <swiper-slide class="head1">
          <div class="second">
            <div class="swiperCon swiperManage"></div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="loginBox">
      <div class="loginRight fr loginPhone">
        <h3 class="ft18 textAlign loginTitle">用户登录</h3>
        <p class="errorHint" v-show="errorBox">
          <img src="../../assets/images/login/warning_icon.png">
          {{error}}
        </p>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          @keyup.enter.native
        >
          <el-form-item label prop="logPhone">
            <el-input
              type="text"
              v-model="ruleForm.logPhone"
              placeholder="手机号/邮箱"
              autocomplete="off"
              autofocus="autofocus"
              @keyup.enter.native="submitForm('ruleForm')"
              id="photo"
            ></el-input>
          </el-form-item>
          <el-form-item label prop="logPwd">
            <el-input
              type="password"
              v-model="ruleForm.logPwd"
              placeholder="密码"
              autocomplete="off"
              autofocus="autofocus"
              @keyup.enter.native="submitForm('ruleForm')"
            ></el-input>
          </el-form-item>
          <el-form-item label prop="logCode">
            <el-input
              type="text"
              v-model="ruleForm.logCode"
              placeholder="请输入验证码"
              autocomplete="off"
              @keyup.enter.native="submitForm('ruleForm')"
            ></el-input>
            <span class="code">
              <img @click="codeFn" :src="ruleForm.img">
            </span>
          </el-form-item>
          <el-form-item>
            <el-button
              v-if="notLogin"
              type="primary"
              id="submitFn"
              @click="submitForm('ruleForm')"
            >登录</el-button>
            <el-button
              v-if="!notLogin"
              type="primary"
              id="submitFn"
              :disabled="true"
              v-loading="loading"
            >登录</el-button>
          </el-form-item>
          <div class="lgTigger">
            <span class="fl ft12" @click="phoneLogin(1,'ruleForm')">手机短信登录</span>
            <router-link class="fr ft12" tag="span" to="Forgetpwd">忘记密码</router-link>
            <router-link class="fr ft12" tag="span" to="Register">立即注册&nbsp;/&nbsp;</router-link>
          </div>
        </el-form>
      </div>
      <div class="loginRight fr loginCode">
        <h3 class="ft18 textAlign loginTitle">手机登录</h3>
        <p class="errorHint" v-show="errorBox">
          <img src="../../assets/images/login/warning_icon.png">
          {{error}}
        </p>
        <el-form
          :model="ruleForm2"
          :rules="rules2"
          ref="ruleForm2"
          label-width="100px"
          class="demo-ruleForm demos-ruleForm"
          @keyup.enter.native
        >
          <el-form-item label prop="logPhone">
            &nbsp;&nbsp;&nbsp;+86&nbsp;&nbsp;&nbsp;
            <el-input
              type="text"
              v-model="ruleForm2.logPhone"
              autofocus="autofocus"
              placeholder="手机号"
              id="photoCode"
              @keyup.enter.native="submitForm2('ruleForm2')"
            ></el-input>
          </el-form-item>
          <el-form-item label prop="logCode">
            <el-input
              type="text"
              v-model="ruleForm2.logCode"
              autofocus="autofocus"
              placeholder="请输入验证码"
              autocomplete="off"
              @keyup.enter="submitForm2('ruleForm2')"
            ></el-input>
            <span v-show="sendAuthCode" class="code PhotoCode" @click="getCode">获取验证码</span>
            <span
              v-show="!sendAuthCode"
              class="code PhotoCode"
              style="color:#D81212;border-color:#a5303d;"
            >{{auth_time}}秒后重新获取</span>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              id="submitFns"
              @click="submitForm2('ruleForm2')"
              v-if="notLoginP"
            >登录</el-button>
            <el-button
              type="primary"
              id="submitFns"
              v-loading="loading"
              :disabled="true"
              v-if="!notLoginP"
            >登录</el-button>
          </el-form-item>
          <p>
            <span class="ft12 switchUser" @click="phoneLogin(2,'ruleForm2')">用户名密码登录</span>
          </p>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
// import Swiper from "swiper";
import { swiper } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import BaseApi from "@lib/baseApi.js";
import md5 from "@lib/encryption.js";
import { mapMutations } from "vuex";
export default {
  components: {},
  data() {
    var validateName = (rule, value, callback) => {
      var emilReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      var photoReg = /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/;
      if (photoReg.test(value) || emilReg.test(value)) {
        var params = { account: value };
        BaseApi.createRpcToken("/user/checkAccount", params)
          .then(data => {
            if (data.datas.code == 3007) {
              this.isExist = false;
            } else if (data.datas.code == 3001) {
              this.isExist = true;
            }
            if (!photoReg.test(value) && !emilReg.test(value)) {
              callback(new Error("用户名格式错误"));
            } else if (this.isExist == true) {
              callback();
            } else if (this.isExist == false) {
              callback(new Error("用户不存在"));
            } else {
              callback();
            }
          })
          .catch(function(e) {
            errorLog(e);
          });
      } else {
        if (!photoReg.test(value) && !emilReg.test(value)) {
          callback(new Error("用户名格式错误"));
        }
        callback();
      }
    };
    var validatePhoto = (rule, value, callback) => {
      var photoReg = /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/;
      if (photoReg.test(value)) {
        var queryStr = {
          account: value
        };
        BaseApi.createRpcToken("/user/checkAccount", queryStr)
          .then(data => {
            if (data.datas.code == 3007) {
              this.isExistPhoto = false;
            } else if (data.datas.code == 3001) {
              this.isExistPhoto = true;
            }
            if (!photoReg.test(value) && !emilReg.test(value)) {
              callback(new Error("用户名格式错误"));
            } else if (this.isExistPhoto == true) {
              callback();
            } else if (this.isExistPhoto == false) {
              callback(new Error("用户不存在"));
            } else {
              callback();
            }
          })
          .catch(function(e) {
            errorLog(e);
          });
      }
    };
    return {
      swiperOption: {
        autoplay: {
          disableOnInteraction: false, //用户操作后是否禁止自动循环
          delay: 3000 //自自动循环时间
        },
        loop: true,
        speed: 300
      },
      error: "",
      notLogin: true,
      notLoginP: true,
      errorBox: false,
      sendAuthCode: true,
      auth_time: 0,
      loading: false,
      isExist: true,
      isExistPhoto: "",
      ruleForm: {
        logPhone: "",
        logPwd: "",
        logCode: "",
        img: ""
      },
      rules: {
        logPhone: [
          { required: true, message: "请输入手机号或邮箱", trigger: "blur" },
          { validator: validateName, trigger: "blur" }
        ],
        logPwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
        logCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ]
      },
      ruleForm2: {
        logPhone: "",
        logCode: ""
      },
      rules2: {
        logPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/,
            message: "非手机号格式",
            trigger: "blur"
          }
          // { validator: validatePhoto, trigger: "blur" }
        ],
        logCode: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      }
    };
  },
  created() {
    BaseApi.createRpcToken("/common/getCode").then(
        data => {
          this.ruleForm.img = "data:image/png;base64," + data.datas.code;
        },
        data => {
        }
      )
      .catch(function(e) {
        errorLog(e);
      });
    // 获取地理位置
    this.getLocation();
  },
  methods: {
    ...mapMutations(["setUserInfo", "setLocation"]),
    phoneLogin(num, formName) {
      this.errorBox = false;
      this.$refs["ruleForm"].resetFields();
      this.$refs["ruleForm2"].resetFields();
      if (num == 1) {
        $(".loginPhone").css("display", "none");
        $(".loginCode").css("display", "block");
        $(document).keyup(function(event) {
          if (event.keyCode == 13) {
            $("#submitFns").trigger("click");
            $("#submitFn").trigger("");
          }
        });
      } else {
        $(document).keyup(function(event) {
          if (event.keyCode == 13) {
            $("#submitFns").trigger("");
            $("#submitFn").trigger("click");
          }
        });
        $(".loginPhone").css("display", "block");
        $(".loginCode").css("display", "none");
      }
    },
    submitForm(formName) {
      sessionStorage.clear();
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.notLogin = false;
          var queryStr = {
            account: this.ruleForm.logPhone,
            password: md5.md5(this.ruleForm.logPwd),
            imageCode: this.ruleForm.logCode
          };
          BaseApi.createRpcToken("/user/login", queryStr, "post", "", "", false)
            .then(
              data => {
                this.notLogin = false;
                if (data.code == 200) {
                  this.loading = false;
                  this.errorBox = false;
                  localStorage.setItem("token", data.datas.token);
                  localStorage.setItem("userId", data.datas.userId);
                  BaseApi.createRpcToken("/user/v2/getUserInfo").then(
                    data => {
                      sessionStorage.setItem(
                        "userInfo",
                        JSON.stringify(data.datas)
                      );
                      localStorage.setItem("curID", data.datas.currentUserId);
                      this.setUserInfo(data.datas);
                      localStorage.loginType = "password";
                      // localStorage.setItem("curUserId", data.datas.currentUserId);
                      this.$router.push({
                        path: "/personal/home"
                      });
                    },
                    err => {}
                  );
                } else {
                  this.notLogin = true;
                }
              },
              data => {
                this.notLogin = true;
                this.errorBox = true;
                this.loading = false;
                this.error = data.message;
                this.codeFn();
              }
            )
            .catch(function(e) {
              errorLog(e);
            });
        } else {
          this.notLogin = true;
          this.loading = false;
          return false;
        }
      });
    },
    getLocation() {
      // BaseApi.createRpcToken("/getToken").then(
      //   data => {
      //     window.token = data.result;
      //   },
      //   err => {}
      // );
      
      BaseApi.createRpcToken("/getLocation")
        .then(
          data => {
            let dataTemp = {
              location: data.result.ad_info.city + data.result.ad_info.district,
              LocationAttr:
                data.result.location.lng + "," + data.result.location.lat
            };
            this.setLocation(dataTemp);
            sessionStorage.setItem("locationInfo", JSON.stringify(dataTemp));
          },
          err => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    submitForm2(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.notLoginP = false;
          var queryStr = {
            account: this.ruleForm2.logPhone,
            smsCode: this.ruleForm2.logCode
          };
          BaseApi.createRpcToken("/user/login", queryStr, "post", "", "", false)
            .then(
              data => {
                this.notLoginP = false;
                if (data.code == 200) {
                  this.errorBox = false;
                  localStorage.setItem("token", data.datas.token);
                  localStorage.setItem("userName", this.ruleForm2.logPhone);
                  this.loading = false;
                  // sessionStorage.setItem("token",data.datas.token);
                  localStorage.loginType = "verificationCode";
                  this.$router.push({
                    path: "/personal/home"
                  });
                } else {
                  this.notLoginP = true;
                }
              },
              data => {
                this.notLoginP = true;
                this.errorBox = true;
                this.loading = false;
                this.error = data.message;
              }
            )
            .catch(function(e) {
              errorLog(e);
            });
        } else {
          this.notLoginP = true;
          this.loading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCode() {
      if (this.ruleForm2.logPhone != "") {
        var photoReg = /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/;
        if (photoReg.test(this.ruleForm2.logPhone)) {
          var queryStr = {
            mobile: this.ruleForm2.logPhone
          };
          BaseApi.createRpcToken("/common/getLoginCode", queryStr)
            .then(
              data => {},
              data => {
                console.log(data);
              }
            )
            .catch(function(e) {
              errorLog(e);
            });
          this.sendAuthCode = false;
          this.auth_time = 60;
          var auth_timetimers = setInterval(() => {
            this.auth_time--;
            if (this.auth_time <= 0) {
              this.sendAuthCode = true;
              clearInterval(auth_timetimers);
            }
          }, 1000);
        }
      } else {
        this.$refs.ruleForm2.validateField("logPhone");
      }
    },
    codeFn() {
      let date = new Date().getTime();
      // this.ruleForm.img = `http://192.168.1.105:8080/common/getCode?date=${date}`;
      BaseApi.createRpcToken(`/common/getCode?date=${date}`)
        .then(
          data => {
            this.ruleForm.img = "data:image/png;base64," + data.datas.code;
          },
          data => {
            console.log(data);
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    }
  },
  comments: {
    swiper
  },
  mounted() {}
};
</script>
<style lang="scss" >
.loginMain {
  width: 100%;
  height: 508px;
  position: relative;
  .loginBanner {
    position: absolute;
    left: 0;
    height: 0;
    right: 0;
    top: 0;
    z-index: -1;
    .first {
      height: 508px;
      background: url("../../assets/images/login/banner01.jpg");
      background-size: 100% 508px;
    }
    .second {
      height: 508px;
      background: url("../../assets/images/login/banner02.jpg");
      background-size: 100% 508px;
    }
    .swiper-slide {
      position: relative;
      height: 100%;
      .swiperCon {
        max-width: 1200px;
        margin: 0 auto;
        height: 100%;
        position: relative;
        .bannerCon {
          color: #fff;
          width: 400px;
          height: 150px;
          margin: auto 0;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          h2 {
            font-size: 46px;
            font-weight: normal;
            letter-spacing: 0;
          }
          .realTime {
            line-height: 28px;
            opacity: 0.8;
            margin: 10px 0;
          }
          .contract {
            line-height: 28px;
            width: 252px;
            height: 44px;
            line-height: 44px;
            background-color: rgba(255, 255, 255, 0.1);
            span {
              color: #fff;
            }
          }
        }
      }
      .swiperManage {
        left: 50%;
        margin-left: -200px;
      }
    }
  }
  .loginBox {
    position: relative;
    max-width: 1200px;
    height: 508px;
    margin: 0 auto;
    .loginRight {
      width: 330px;
      overflow: hidden;
      background-color: #fff;
      padding: 0 30px;
      box-sizing: border-box;
      margin: 56px 0;
      border-radius: 4px;
      box-shadow: 0 2px 8px 0;
      padding-bottom: 37px;
      .errorHint {
        width: 270px;
        height: 28px;
        line-height: 28px;
        background: #fffbf3;
        border: 1px solid #ff8c36;
        font-size: 12px;
        text-indent: 10px;
        color: #646464;
        img {
          vertical-align: middle;
          margin-right: 4px;
        }
      }
      .loginTitle {
        color: #5f5f5f;
        line-height: 18px;
        font-weight: normal;
        margin-top: 29px;
        margin-bottom: 27px;
        font-family: "PingFangSC-Regular";
      }
      p {
        margin-bottom: 22px;
        input {
          width: 270px;
          height: 36px;
        }
        .inputText {
          border: 1px solid #d1d1d1;
          text-indent: 10px;
        }
        .loginBtn {
          background: #D81212;
          color: #fff;
          font-family: "PingFangSC-Regular ";
          border: none;
        }
        .loginBtn:hover {
          background: #b41c2e;
        }
      }
      p:nth-child(2) {
        margin-bottom: 10px;
      }
      .lgTigger {
        color: #5f5f5f;
        span {
          cursor: pointer;
        }
        span:hover {
          color: #D81212;
        }
      }
      .codeCon {
        input {
          width: 166px;
          height: 36px;
          border: 1px solid #d1d1d1;
          text-indent: 10px;
        }
        .verCode {
          display: inline-block;
          width: 90px;
          height: 36px;
          border: 1px solid #d1d1d1;
          margin-left: 10px;
          vertical-align: middle;
        }
      }
      .el-form-item {
        width: 270px;
        height: 36px;
        .el-form-item__content {
          line-height: 36px;
          margin: 0 !important;
          .el-input {
            height: 36px;
          }
          .el-input__inner {
            height: 100%;
            border-radius: 0;
          }
          .el-button--primary {
            height: 36px;
            width: 100%;
            background: #D81212;
            border: none;
          }
          .el-button--primary:hover {
            background-color: #a5303d;
          }
        }
        .code {
          display: block;
          float: right;
          width: 90px;
          height: 34px;
          line-height: 34px;
          text-align: center;
          border: 1px solid #d1d1d1;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .PhotoCode {
          width: 110px;
        }
      }
      .el-form-item:nth-child(3) {
        .el-input {
          width: 160px;
        }
      }
      .demos-ruleForm {
        .el-form-item:nth-child(1) {
          border: 1px solid #d1d1d1;
          .el-input__inner {
            border: 0;
            border-left: 1px solid #d1d1d1;
          }
          .el-input {
            width: 80%;
          }
        }
        .el-form-item:nth-child(2) {
          .el-input {
            width: 140px;
          }
        }
      }
    }
    .loginCode {
      display: none;
      overflow: hidden;
      padding-bottom: 0;
      margin: 102px 0;
      .codePhone {
        border: 1px solid #d1d1d1;
        span {
          display: inline-block;
          width: 50px;
          text-align: center;
          border-right: 1px solid #dcdcdc;
          vertical-align: middle;
        }
        input {
          width: 217px;
          text-indent: 10px;
        }
      }
      .codeVerify {
        border: 1px solid #d1d1d1;
        span {
          display: inline-block;
          width: 100px;
          text-align: center;
          border-left: 1px solid #dcdcdc;
          vertical-align: middle;
          font-size: 14px;
        }
        span:hover {
          color: #D81212;
        }
        input {
          width: 167px;
          text-indent: 10px;
        }
      }
      .switchUser {
        font-family: "PingFangSC-Regular";
        color: #5f5f5f;
        line-height: 12px;
        cursor: pointer;
      }
      .switchUser:hover {
        color: #D81212;
      }
    }
  }
  .el-loading-spinner {
    margin-top: -10px;
    .circular {
      height: 20px;
      width: 20px;
    }
  }
}
</style>
